import React from "react";
import { Box, Button, InputBase, Modal, Typography, Input, IconButton, Tooltip,Checkbox, InputAdornment, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { updatesearchProduct } from "../../Redux/page";
import SearchIcon from '@mui/icons-material/Search';
import { ProductTable } from "../../sub_components/product_table";
import { useEffect, useState } from "react";
import { Editor } from "primereact/editor";
import AddIcon from '@mui/icons-material/Add';
import '../../App.css';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Dropdown } from 'primereact/dropdown';
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { updateEdit, updateModal, updateProductDetail, updateProducts } from "../../Redux/products";
import { updateCategoryDetails } from "../../Redux/category-redux";
import { Toast } from 'primereact/toast';
import { useRef } from "react";
import * as Yup from "yup";
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import CustomAxios from "../../utils/CustomAxios";
import { blobSrc, getProductImageUrls } from "../../utils/blobUrl";
import { OrderModal, OrderModalDelivery, useGetInventory, useGetProducts } from "../globalFunctions";
import { updateUpdatedDate } from "../../Redux/orders";
import CircularProgress from '@mui/material/CircularProgress';
import { useGetCategories, useGetSubCategories } from "../globalFunctions";
import { MultiSelect } from "primereact/multiselect";
import dayjs from "dayjs";
import { LocalizationProvider, MobileTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Autocomplete, Chip } from '@mui/material';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';



export function ProductDetails() {
    const dispatch = useDispatch()
    const toast = useRef(null);
    const authToken = localStorage.getItem('authtoken')
    const modal = useSelector(state => state.products.modal)
    const productDetails = useSelector(state => state.products.productdetail)
    const inventory = useSelector(state => state.inventory.inventory);
    const edit = useSelector(state => state.products.edit)
    const actcategory = useSelector(state => state.category.category)
    const [category, setCategory] = useState([])
    const [subCategory, setSubCategory] = useState([])
    const sub_category = useSelector(state => state.subcategory.subcategory)
    const getSubCategory = useGetSubCategories();
    const getCategory = useGetCategories()
    const getInventory = useGetInventory()
    const [imagePreviews, setImagePreviews] = useState([]);
    const [loading, setLoading] = useState(false)
    const [errors, setErrors] = useState({});
    const categoryModal = useSelector(state => state.category.modal);
    const categoryEdit = useSelector(state => state.category.categoryEdit);
    const categoryDetails = useSelector(state => state.category.categoryDetails);
    const [formData, setFormData] = useState({
        inventory: [],
        capacitydetails: {}, 
        images: [],
        addons: [],
    });
    const getProducts = useGetProducts()
    const selectedHub = useSelector(state => state.user.selected_hub)?.[0]; // gets ID
    const [filteredInventory, setFilteredInventory] = useState([]);
    const user_role = localStorage.getItem('role');
    
    // Check if user can manage products (create, edit, delete)
    const canManageProducts = ['super_admin', 'admin', 'supervisor'].includes(user_role);
    const [openTimeModal, setOpenTimeModal] = useState(false);
    const [modalErrors, setModalErrors] = useState({
        available_from: '',
        available_to: ''
    });

    // Date & time modal state (react-datepicker)
    const [openDateRangeModal, setOpenDateRangeModal] = useState(false);
    const [dateRangeContext, setDateRangeContext] = useState({ inventoryId: null, capIndex: null });
    const [modalStartDateTime, setModalStartDateTime] = useState(null);
    const [modalEndDateTime, setModalEndDateTime] = useState(null);
    const [modalDaysOfWeek, setModalDaysOfWeek] = useState([]);
    const [modalRepeatMode, setModalRepeatMode] = useState('year'); // 'year' | 'month' | 'custom'
    const [modalError, setModalError] = useState('');

    // MUI TextField wrapper for react-datepicker
    const DateTextField = React.useMemo(() => React.forwardRef(({ value, onClick, label, placeholder }, ref) => (
        <TextField
            inputRef={ref}
            onClick={onClick}
            value={value || ''}
            label={label}
            placeholder={placeholder}
            size="small"
            fullWidth
            InputProps={{ readOnly: true }}
        />
    )), []);

    // Helper functions for dynamic date calculations
    const getLastDayOfYear = (date) => {
        const year = date.getFullYear();
        return new Date(year, 11, 31); // December 31st
    };

    const getLastDayOfMonth = (date) => {
        const year = date.getFullYear();
        const month = date.getMonth();
        return new Date(year, month + 1, 0); // Last day of the month
    };

    const isPastDate = (date) => {
        const now = new Date();
        return date < now;
    };

    const calculateEndDate = (startDate, repeatMode) => {
        if (!startDate) return null;
        
        switch (repeatMode) {
            case 'year':
                return getLastDayOfYear(startDate);
            case 'month':
                return getLastDayOfMonth(startDate);
            case 'custom':
                return startDate; // User can select freely
            default:
                return startDate;
        }
    };

    // Handle start date change with dynamic end date calculation
    const handleStartDateChange = (newStartDate) => {
        setModalStartDateTime(newStartDate);
        
        // Auto-calculate end date based on repeat mode
        if (newStartDate && modalRepeatMode !== 'custom') {
            const calculatedEndDate = calculateEndDate(newStartDate, modalRepeatMode);
            if (calculatedEndDate) {
                // Preserve the time from current end date if it exists, otherwise use start time
                const currentEndTime = modalEndDateTime;
                const newEndDate = new Date(calculatedEndDate);
                
                if (currentEndTime) {
                    newEndDate.setHours(currentEndTime.getHours());
                    newEndDate.setMinutes(currentEndTime.getMinutes());
                    newEndDate.setSeconds(currentEndTime.getSeconds());
                } else {
                    // Use start time as default
                    newEndDate.setHours(newStartDate.getHours());
                    newEndDate.setMinutes(newStartDate.getMinutes());
                    newEndDate.setSeconds(newStartDate.getSeconds());
                }
                
                setModalEndDateTime(newEndDate);
            }
        }
    };

    // Handle repeat mode change with dynamic end date calculation
    const handleRepeatModeChange = (newRepeatMode) => {
        setModalRepeatMode(newRepeatMode);
        
        if (modalStartDateTime && newRepeatMode !== 'custom') {
            const calculatedEndDate = calculateEndDate(modalStartDateTime, newRepeatMode);
            if (calculatedEndDate) {
                // Preserve the time from current end date if it exists
                const currentEndTime = modalEndDateTime;
                const newEndDate = new Date(calculatedEndDate);
                
                if (currentEndTime) {
                    newEndDate.setHours(currentEndTime.getHours());
                    newEndDate.setMinutes(currentEndTime.getMinutes());
                    newEndDate.setSeconds(currentEndTime.getSeconds());
                } else {
                    // Use start time as default
                    newEndDate.setHours(modalStartDateTime.getHours());
                    newEndDate.setMinutes(modalStartDateTime.getMinutes());
                    newEndDate.setSeconds(modalStartDateTime.getSeconds());
                }
                
                setModalEndDateTime(newEndDate);
            }
        }
        
        // Set default days for year and month modes
        if (newRepeatMode === 'year' || newRepeatMode === 'month') {
            setModalDaysOfWeek([0,1,2,3,4,5,6]);
        }
    };

    const [instructionOptions, setInstructionOptions] = useState([]); // [{ label, value }, ...]
    const [selectedInstructionIds, setSelectedInstructionIds] = useState([]); // [id,...]
    const prevSelectedInstructionIdsRef = useRef([]); // for diff on update
    // const products = useSelector(state => state.products.products.filter(product => product.item_category =='Addon'))
    
    const selectedInventoryIds = formData?.inventory || [];
    const products = useSelector(state =>
        state.products.products
            .filter(product => product.item_category === "Addon")
            .filter(product => {
                if (!product.capacitydetails) return false;

                // flatten capacitydetails into a single array of capacities
                const capacities = Object.values(product.capacitydetails)
                    .flatMap(detail => detail.capacities || []);

                // check if any inventory_id matches formData inventory
                return capacities.some(cap => selectedInventoryIds.includes(cap.inventory_id));
            })
    );


    useEffect(() => {
        if (formData.addons && formData.addons.length > 0) {
            const validAddons = products.map(p => p.id); // IDs of available addons
            const filteredAddons = formData.addons.filter(a => validAddons.includes(a));

            if (filteredAddons.length !== formData.addons.length) {
                setFormData(prev => ({
                    ...prev,
                    addons: filteredAddons
                }));
            }
        }
    }, [products, formData.addons, setFormData]);

    // console.log('full products------------>>',products)



    const availabilityOptions = [
        { label: "All Time", value: "all_time" },
        { label: "Specific", value: "specific" },
    ];

    const daysOfWeek = [
        { label: 'Sun', value: 0 },
        { label: 'Mon', value: 1 },
        { label: 'Tue', value: 2 },
        { label: 'Wed', value: 3 },
        { label: 'Thu', value: 4 },
        { label: 'Fri', value: 5 },
        { label: 'Sat', value: 6 },
    ];

    const idToOption = React.useMemo(
        () => new Map(instructionOptions.map(o => [o.value, o])),
        [instructionOptions]
    );

    // Build selected option objects from IDs (same refs as in options)
    const selectedOptions = React.useMemo(
        () => selectedInstructionIds.map(id => idToOption.get(id)).filter(Boolean),
        [selectedInstructionIds, idToOption]
    );

    useEffect(() => {
        const role = localStorage.getItem('role');
        const total_hub = JSON.parse(localStorage.getItem('hub')) || [];

        // Build inventory options: show all, but disable unassigned for restricted roles
        const filtered = (inventory || []).map((inv) => {
            const isAssigned = total_hub.includes(inv.value);
            return {
                ...inv,
                name: inv.name ?? 'Not assigned hub',
                disabled: ['admin', 'supervisor', 'customer_engagement_admin'].includes(role) ? !isAssigned : false
            };
        });
        setFilteredInventory(filtered);
    }, [inventory]);


    useEffect(()=>{
        getCategory()
        getSubCategory()
    },[authToken])

    useEffect(()=>{
        const newcategory = actcategory.map(obj=>({
            name:obj.category_name,
            value:obj.category_name
        })

        )
        setCategory(newcategory)
    },[actcategory])
    useEffect(()=>{
        const newcategory = sub_category.map(obj=>({
            name:obj.subcategory_name,
            value:obj.subcategory_name
        })

        )
        setSubCategory(newcategory)
    },[sub_category])
    console.log(category)

    const handleExtraPercentageChange = (invId, index, value) => {
        const updatedList = (formData.capacitydetails?.[invId] || []).map((item, i) => {
            if (i !== index) return item;

            const extraPercentage = value === '' ? 0 : parseFloat(value) || 0;
            const price = parseFloat(item.item_price) || 0;
            const priceWithExtra = price + (price * extraPercentage) / 100;

            return {
                ...item,
                extraPercentage: value === '' ? '' : extraPercentage,
                item_selling_price: priceWithExtra.toFixed(2), 
            };
        });

        setFormData((prev) => ({
            ...prev,
            capacitydetails: {
                ...prev.capacitydetails,
                [invId]: updatedList,
            }
        }));
    };
    
 

    useEffect(() => {
        const updatedCapacityDetails = {};

        Object.entries(formData.capacitydetails || {}).forEach(([invId, capacityList]) => {
            // ✅ ensure it's an array before calling .map()
            if (!Array.isArray(capacityList)) {
                updatedCapacityDetails[invId] = []; // fallback empty array
                return;
            }

            updatedCapacityDetails[invId] = capacityList.map((item) => {
                const price = parseFloat(item.item_price) || 0;
                const extraPercentage = parseFloat(item.extraPercentage) || 0;
                const priceWithExtra = price + (price * extraPercentage) / 100;

                return {
                    ...item,
                    item_selling_price: priceWithExtra.toFixed(2),
                };
            });
        });

        setFormData((prev) => ({
            ...prev,
            capacitydetails: updatedCapacityDetails,
        }));
    }, []);
    
    
    useEffect(() => {
        if (!edit) {
            setFormData(productDetails);
        }
        dispatch(updateUpdatedDate(null))
    }, [productDetails, edit])
    useEffect(() => {
        if (edit && productDetails?.id) {
            const urls = getProductImageUrls(productDetails);
            setImagePreviews(urls);

            const extractedInventoryIds = Object.keys(productDetails.capacitydetails || {}).map(id => parseInt(id));

            // Prefill UI date-time helpers on edit based on available_from_datetime/available_to_datetime
            const hydrateUiTimes = (cd) => {
                const result = {};
                Object.entries(cd || {}).forEach(([inv, items]) => {
                    result[inv] = (items || []).map((it) => {
                        const patched = { ...it };
                        if (it && it.availability_type === 'specific') {
                            // Use new datetime fields if available, fallback to old time fields
                            if (it.available_from_datetime) {
                                patched.ui_startDateTime = it.available_from_datetime;
                            } else if (it.available_from) {
                                // Fallback for old data with only time strings
                                const now = new Date();
                                const [hh = '0', mm = '0', ss = '0'] = String(it.available_from).split(':');
                                const d = new Date(now);
                                d.setHours(parseInt(hh) || 0);
                                d.setMinutes(parseInt(mm) || 0);
                                d.setSeconds(parseInt(ss) || 0);
                                d.setMilliseconds(0);
                                patched.ui_startDateTime = d.toISOString();
                            }
                            
                            if (it.available_to_datetime) {
                                patched.ui_endDateTime = it.available_to_datetime;
                            } else if (it.available_to) {
                                // Fallback for old data with only time strings
                                const now = new Date();
                                const [hh = '0', mm = '0', ss = '0'] = String(it.available_to).split(':');
                                const d = new Date(now);
                                d.setHours(parseInt(hh) || 0);
                                d.setMinutes(parseInt(mm) || 0);
                                d.setSeconds(parseInt(ss) || 0);
                                d.setMilliseconds(0);
                                patched.ui_endDateTime = d.toISOString();
                            }
                            
                            // Set repeat mode and days
                            patched.ui_repeatMode = it.repeat_mode || 'year';
                            patched.ui_daysOfWeek = it.repeat_days || [];
                        }
                        return patched;
                    });
                });
                return result;
            };

            setFormData(prevData => ({
                ...prevData,
                ...productDetails,
                image_urls: urls,
                images: [],
                capacitydetails: hydrateUiTimes(productDetails.capacitydetails),
                inventory: extractedInventoryIds,
            }));
        }
    }, [edit, productDetails]);
    //console.log(productDetails)

    const handleInvChange = (e) => {
        const selectedInventories = e.value;

        // Initialize capacitydetails for each selected inventory
        const newCapacityDetails = { ...formData.capacitydetails };

        selectedInventories.forEach(inv => {
            if (!newCapacityDetails[inv] || newCapacityDetails[inv].length === 0) {
                newCapacityDetails[inv] = [
                    {
                        item_price: "",
                        item_available: true,
                        item_capacity: "",
                        item_quantity: "",
                        item_tax: "",
                        item_selling_price: "",
                        item_offers_price: 0.00,
                        extraPercentage: "",
                        capacityValue: "",
                        item_special_offer: "",
                        unit: "",
                    },
                ];
            }
        });

        // Remove capacity forms for unselected inventories
        Object.keys(newCapacityDetails).forEach(inv => {
            if (!selectedInventories.includes(parseInt(inv))) {
                delete newCapacityDetails[inv];
            }
        });

        setFormData({
            ...formData,
            inventory: selectedInventories,
            capacitydetails: newCapacityDetails,
        });

        setErrors(prev => ({ ...prev, inventory: null }));
    };

    useEffect(() => {
    if (!formData.capacitydetails || typeof formData.capacitydetails !== 'object') {
        setFormData((prev) => ({
            ...prev,
            capacitydetails: {}
        }));
    }
}, [formData.capacitydetails]);


const handleChange = (e) => {
        if (e.htmlValue !== undefined) {
            const name = e.target ? e.target.name : "item_details";
            const value = e.htmlValue;

            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        } else {
            const name = e.target.name;
            let value;

            if (name === "shinos_choice" || name === "bogo") {
                value = e.target.checked;
            }  else if (name === "addons") {
            value = e.value || [];
            // console.log("Selected addons========>", value);
        } else {
                value = e.target.value;
            }

            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };
    // const handleCapacityChange = (index, e) => {
    //     const updatedCapacityDetails = formData?.capacitydetails?.map((item, i) =>
    //       i === index ? { ...item, [e.target.name]: e.target.value } : item
    //     );
    //     //console.log(updatedCapacityDetails)
    //     setFormData({ ...formData, capacitydetails: updatedCapacityDetails });
    //   }

    // console.log('data-------?',formData)
      
    const handleCapacityChange = (invId, index, e) => {
    let name, value;

    if (e?.target) {
        name = e.target.name;
        value = e.target.value;
    } else if (e?.value !== undefined && e?.originalEvent) {
        name = e.originalEvent.target.name;
        value = e.value;
    } else {
        console.warn("Unknown event format:", e);
        return;
    }

    setFormData((prevFormData) => {
        const updatedItem = {
            ...prevFormData.capacitydetails[invId][index],
            [name]: value,
        };

        // Recalculate dependent values
        if (name === 'item_price' || name === 'extraPercentage') {
            const price = parseFloat(updatedItem.item_price) || 0;
            const extra = parseFloat(updatedItem.extraPercentage) || 0;
            updatedItem.item_selling_price = (price + (price * extra) / 100).toFixed(2);
        }

        if (name === 'item_special_offer') {
            updatedItem.item_offers_price = value
                ? (parseFloat(updatedItem.item_selling_price) - ((parseFloat(value) / 100) * parseFloat(updatedItem.item_selling_price))).toFixed(2)
                : 0;
        }

        if (name === 'capacityValue' || name === 'unit') {
            updatedItem.item_capacity = `${updatedItem.capacityValue ?? ''} ${updatedItem.unit ?? ''}`.trim();
        }

        if (name === 'availability_type') {
            if (value === 'specific') {
                // Open date-time modal immediately with prefilled values
                setDateRangeContext({ inventoryId: invId, capIndex: index });
                const startDate = updatedItem.ui_startDateTime ? new Date(updatedItem.ui_startDateTime) : null;
                const endDate = updatedItem.ui_endDateTime ? new Date(updatedItem.ui_endDateTime) : null;
                const repeatMode = updatedItem.ui_repeatMode || 'year';
                
                setModalStartDateTime(startDate);
                setModalEndDateTime(endDate);
                setModalDaysOfWeek(Array.isArray(updatedItem.ui_daysOfWeek) ? updatedItem.ui_daysOfWeek : []);
                setModalRepeatMode(repeatMode);
                
                // If no end date exists, calculate it based on repeat mode
                if (startDate && !endDate) {
                    const calculatedEndDate = calculateEndDate(startDate, repeatMode);
                    if (calculatedEndDate) {
                        const newEndDate = new Date(calculatedEndDate);
                        newEndDate.setHours(startDate.getHours());
                        newEndDate.setMinutes(startDate.getMinutes());
                        newEndDate.setSeconds(startDate.getSeconds());
                        setModalEndDateTime(newEndDate);
                    }
                }
                
                setOpenDateRangeModal(true);
            } else {
                updatedItem.available_from = '';
                updatedItem.available_to = '';
                // clear UI-only fields
                delete updatedItem.ui_startDateTime;
                delete updatedItem.ui_endDateTime;
                delete updatedItem.ui_daysOfWeek;
            }
        }

        const updatedList = [...prevFormData.capacitydetails[invId]];
        updatedList[index] = updatedItem;

        return {
            ...prevFormData,
            capacitydetails: {
                ...prevFormData.capacitydetails,
                [invId]: updatedList,
            },
        };
    });
};


    const handleAddCapacity = (invId) => {
        const currentCapacities = formData.capacitydetails?.[invId] || [];

        const newCapacity = {
            item_price: "",
            item_available: true,
            item_capacity: "",
            item_quantity: "",
            item_tax: "",
            item_selling_price: "",
            item_offers_price: 0.00,
            extraPercentage: "",
            capacityValue: "",
            unit: "",
            item_special_offer:"",
            availability_type : "all_time",
            available_from : "",
            available_to : ""

        };
        setFormData((prevFormData) => ({
            ...prevFormData,
            capacitydetails: {
                ...prevFormData.capacitydetails,
                [invId]: [...currentCapacities, newCapacity],
            },
        }));
    };

const handleRemoveCapacity = (invId, index) => {
    const updatedCapacities = formData.capacitydetails[invId].filter((_, i) => i !== index);

    setFormData((prevFormData) => ({
        ...prevFormData,
        capacitydetails: {
            ...prevFormData.capacitydetails,
            [invId]: updatedCapacities,
        },
    }));
};


    // const category = [
    //     { name: 'Food', value: 'food' },
    //     { name: 'Meat', value: 'meat' },
    //     { name: 'Vegetables', value: 'vegetables' },
    //     { name: 'Provisions', value: 'provisions' },
    //     { name: 'Oil & Sauces', value: 'Oil & Sauces' },
    //     { name: 'Dairy & Breads', value: 'Dairy & Breads' },
    //     { name: 'Refreshing Beverages', value: 'Refreshing Beverages'},
    //     { name: 'kitchen appliances', value: 'kitchen appliances'},
    //     // { name: 'Mojitos', value: 'Mojitos' },
    //     // { name: 'Cool Drinks', value: 'Cool Drinks' },
    // ];
    const criteria = [
        { name: 'Veg', value: 'veg' },
        { name: 'Non - veg', value: 'non-veg' },
        { name: 'kitchen appliances', value: 'kitchen appliances' },
    ];
    const capacity = [
        { name: 'grams', value: 'gms' },
        { name: 'kilogram', value: 'kg' },
        { name: 'litre', value: 'ltr' },
        { name: 'box', value: 'box' },
        { name: 'cups', value: 'cups' },
        { name: 'ml', value: 'ml' },
        { name: 'pieces', value: 'pieces' },
        { name: 'bunch', value: 'bunch' },
        { name: 'packet', value: 'packet' },
        { name: 'bottle', value: 'bottle' },
        { name: 'offer', value: 'offer' },
    ];
    const availability = [
        { name: 'Available', value: true },
        { name: 'Out of stock', value: false },
    ];

    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);
        setFormData({
            ...formData,
            images: [...formData?.images, ...files]
        });
        if (edit) {
            const url = URL.createObjectURL(e.target.files[0]);
            setImagePreviews(prev => ([...prev, url]));
        }else{
            const previews = files?.map((file) => URL.createObjectURL(file));
            setImagePreviews(prev => ([...prev, ...previews]));
        }
        // dispatch(updateProductDetail('images', files));
    };

    // useEffect(() => {
    //     if (formData?.images?.length > 0 && !edit && !modal) {
    //         console.log("in photo");
    //         const previews = formData.images.map((file) => URL.createObjectURL(file));
    //         setImagePreviews(previews);
    //     }
    //     return () => {
    //         formData?.images?.forEach((file) => URL.revokeObjectURL(file));
    //     };
    // }, [formData?.images, edit,modal]);
    const handleRemoveImage = (index) => {
        if (!edit) {
            const newImages = formData?.images?.filter((_, i) => i !== index);
            setFormData((prevData) => ({ ...prevData, images: newImages ?? [] }));
            setImagePreviews((formData?.images || []).filter((_, i) => i !== index));
            return;
        }

        const newImageUrls = (formData?.image_urls || imagePreviews || []).filter((_, i) => i !== index);
        const newFiles = (formData?.images || []).filter((file) => file instanceof File);
        setFormData((prevData) => ({
            ...prevData,
            image_urls: newImageUrls,
            images: newFiles,
        }));
        setImagePreviews(newImageUrls);
    };

const handleOpen = () => {
    setErrors({});
    const role = localStorage.getItem('role');
    const total_hub = JSON.parse(localStorage.getItem('hub')) || [];

    let defaultInventory = [];

    if (role === 'supervisor') {
        if (total_hub.length === 1) {
            defaultInventory = [total_hub[0]];
        } else {
            defaultInventory = []; // supervisor with multiple hubs can choose
        }
    }

    dispatch(updateProductDetail({
        item_name: "",
        item_description: "",
        item_category: "",
        item_criteria: "",
        inventory: defaultInventory,
        images: [],
        item_details: "",
        capacitydetails: [{
            item_price: "",
            item_available: true,
            item_capacity: "",
            item_quantity: "",
            item_tax: "",
            item_selling_price: "",
            item_offers_price: 0.00,
            extraPercentage: "",
            capacityValue: "",
            item_special_offer:"",
            unit: "",
            availability_type : "all_time",
            available_from : "",
            available_to : ""
        }]
    }));
    dispatch(updateEdit(false));
    dispatch(updateModal(true));
};

    const handleClose = () => {
        setErrors({})
        dispatch(updateModal(false)); 
        dispatch(updateEdit(false))
        dispatch(updateProductDetail({
            item_name: "",
            item_description: "",
            item_category: "",
            item_criteria: "",
            images: [],
            item_details: "",
            // product_group_id: "",
            capacitydetails: [{ 
                item_price: "",
                item_available: true,
                item_capacity: "",
                item_quantity: "",
                item_tax: "",
                item_selling_price: "",
                item_offers_price: 0.00,
                extraPercentage : "",
                availability_type : "all_time",
                available_from : "",
                available_to : ""

            }]
        }));
        setImagePreviews([])
    };


   const handleSaveProducts = async () => {

    Object.keys(formData.capacitydetails || {}).forEach(invId => {
    const caps = formData.capacitydetails[invId];

    if (Array.isArray(caps)) {
        caps.forEach((cap, idx) => {
        if (!cap.extraPercentage || cap.extraPercentage.toString().trim() === "") {
            cap.extraPercentage = "0";
        }
        if (!cap.item_special_offer || cap.item_special_offer.toString().trim() === "") {
            cap.item_special_offer = "0";
        }
        });
    } else {
        console.warn(`Expected array for capacitydetails[${invId}], but got:`, caps);
    }
    });

    const data = new FormData();

    // ✅ Manual check for at least one image
    if (!formData?.images || formData.images.length === 0) {
        toast.current.show({
            severity: 'error',
            summary: 'Error',
            detail: 'Please upload at least one image',
            life: 3000
        });
        return;
    }

    // ✅ Append images to FormData
    if (Array.isArray(formData.images)) {
        formData.images.forEach((file) => {
            if (file instanceof File) {
                data.append('images', file);
            } else {
                console.error('Expected a File object, but got:', file);
            }
        });
    }


    // ✅ Flatten capacitydetails to match backend
const flattenedCapacities = [];

Object.entries(formData.capacitydetails || {}).forEach(([inventoryId, items]) => {
    if (Array.isArray(items)) {
        items.forEach((rawItem) => {
            const cleanedItem = {};

            // Clean nested quoted strings (e.g., "\"100\"" => "100")
            Object.entries(rawItem).forEach(([key, value]) => {
                if (typeof value === "string") {
                    try {
                        cleanedItem[key] = JSON.parse(value); // removes extra quotes
                    } catch {
                        cleanedItem[key] = value; // fallback to raw string
                    }
                } else {
                    cleanedItem[key] = value;
                }
            });

            cleanedItem.capacity = `${cleanedItem.capacityValue ?? ''} ${cleanedItem.unit ?? ''}`.trim();
            cleanedItem.inventory = parseInt(inventoryId);

            // Ensure availability_type and times are included
            cleanedItem.availability_type = cleanedItem.availability_type || "";
            if (cleanedItem.availability_type === 'specific') {
            // keep as is
            cleanedItem.available_from = cleanedItem.available_from || '';
            cleanedItem.available_to = cleanedItem.available_to || '';
            // Also include full datetime (ISO) for backend if needed
            if (cleanedItem.ui_startDateTime) {
                cleanedItem.available_from_datetime = cleanedItem.ui_startDateTime;
            }
            if (cleanedItem.ui_endDateTime) {
                cleanedItem.available_to_datetime = cleanedItem.ui_endDateTime;
            }
            // Include repeat settings
            cleanedItem.repeat_mode = cleanedItem.ui_repeatMode || 'year';
            cleanedItem.repeat_days = cleanedItem.ui_daysOfWeek || [];
        } else {
            // remove the keys entirely for 'all_time'
            delete cleanedItem.available_from;
            delete cleanedItem.available_to;
            delete cleanedItem.available_from_datetime;
            delete cleanedItem.available_to_datetime;
        }

            // Strip UI-only fields
            delete cleanedItem.ui_startDateTime;
            delete cleanedItem.ui_endDateTime;
            delete cleanedItem.ui_daysOfWeek;
            delete cleanedItem.ui_crossesMidnight;


            flattenedCapacities.push(cleanedItem);
        });
    } else {
        console.warn(`Expected array for inventory ${inventoryId}, but got:`, items);
    }
});

    // ✅ Append flattened capacities
    data.append('capacities', JSON.stringify(flattenedCapacities));

    // ✅ Append other fields (excluding images and capacitydetails)
   Object.entries(formData).forEach(([key, value]) => {
    if (key === 'addons' && Array.isArray(value)) {
        value.forEach((addonId) => {
            data.append("addons", addonId);  // append each ID separately
        });
    } else if (key !== 'images' && key !== 'capacitydetails') {
        data.append(key, typeof value === 'boolean' ? value.toString() : value);
    }
});

    // ✅ Log FormData content
    console.log("🧾 FormData Preview:");
    for (let [key, val] of data.entries()) {
        console.log(`keyval ${key}:`, val);
    }

    // ✅ Validation with flattened capacitydetails
    const formDataForValidation = {
        ...formData,
        capacitydetails: flattenedCapacities
    };

    try {
        await validationSchema.validate(formDataForValidation, { abortEarly: false });
        setErrors({});
        setLoading(true);

        // ✅ Make POST request
        await CustomAxios.post(`products/add/`, data);
        toast.current.show({ severity: 'success', summary: 'Success', detail: 'Product Added Successfully', life: 3000 });

        getProducts();
        handleClose();
        setFormData([]);
        dispatch(updateModal(false));
        setLoading(false);
    } catch (validationErrors) {
        setLoading(false);
        if (validationErrors.name === "ValidationError") {
            const formErrors = {};
            validationErrors.inner.forEach((error) => {
                formErrors[error.path] = error.message;
            });
            setErrors(formErrors);
        } else if (axios.isAxiosError(validationErrors)) {
            console.error("Axios error:", validationErrors);
            
            // Handle backend validation errors
            if (validationErrors.response && validationErrors.response.data) {
                const errorData = validationErrors.response.data;
                
                // Handle Django validation errors (array format)
                if (Array.isArray(errorData)) {
                    const cleanMessages = errorData.map(error => {
                        // Handle ErrorDetail objects
                        if (error && typeof error === 'object' && error.string) {
                            return error.string;
                        }
                        // Handle plain strings
                        return String(error);
                    });
                    const errorMessage = cleanMessages.join(', ');
                    toast.current.show({ 
                        severity: 'error', 
                        summary: 'Validation Error', 
                        detail: errorMessage, 
                        life: 5000 
                    });
                }
                // Handle single error message
                else if (typeof errorData === 'string') {
                    toast.current.show({ 
                        severity: 'error', 
                        summary: 'Error', 
                        detail: errorData, 
                        life: 5000 
                    });
                }
                // Handle object with error details
                else if (typeof errorData === 'object') {
                    let errorMessage = errorData.detail || errorData.message || JSON.stringify(errorData);
                    
                    // Handle Django ErrorDetail string format
                    if (typeof errorMessage === 'string' && errorMessage.includes('ErrorDetail')) {
                        // Extract the actual message from ErrorDetail string format
                        // Handles formats like: [ErrorDetail(string='message', code='invalid')]
                        const match = errorMessage.match(/string='([^']+)'/);
                        if (match) {
                            errorMessage = match[1];
                        } else {
                            // Fallback: try to extract any quoted string
                            const fallbackMatch = errorMessage.match(/'([^']+)'/);
                            if (fallbackMatch) {
                                errorMessage = fallbackMatch[1];
                            }
                        }
                    }
                    
                    toast.current.show({ 
                        severity: 'error', 
                        summary: 'Error', 
                        detail: errorMessage, 
                        life: 5000 
                    });
                }
                else {
                    toast.current.show({ 
                        severity: 'error', 
                        summary: 'Save failed', 
                        detail: 'Something went wrong.', 
                        life: 3000 
                    });
                }
            } else {
                toast.current.show({ 
                    severity: 'error', 
                    summary: 'Save failed', 
                    detail: 'Something went wrong.', 
                    life: 3000 
                });
            }
        } else {
            console.error("Unexpected error:", validationErrors);
            toast.current.show({ 
                severity: 'error', 
                summary: 'Error', 
                detail: validationErrors.message || 'Something went wrong.', 
                life: 3000 
            });
        }
    }
};


    const countryOptionTemplate = (option) => {
    // console.log('options--------->>', option);

    const capacityValues = option.capacitydetails ? Object.values(option.capacitydetails) : [];
    const capacityNames = capacityValues.map(cap => cap.name).filter(Boolean).join(", ");

    return (
        <Box sx={{ display: "flex", gap: "10px" }}>
            <Box
                component="img"
                alt={option.item_name}
                src={option.image}
                sx={{ width: "30px", height: "30px", objectFit: "cover" }}
            />
            <Box>
                {option.item_name}{" "}
                {capacityNames && <span style={{ color: "gray" }}>({capacityNames})</span>}
            </Box>
        </Box>
    );
};

const selectedCountryTemplate = (option, props) => {
    // console.log('options------22--->>', option);

    if (option) {
        const capacityValues = option.capacitydetails ? Object.values(option.capacitydetails) : [];
        const capacityNames = capacityValues.map(cap => cap.name).filter(Boolean).join(", ");

        return (
            <Box sx={{ display: "flex", gap: "10px" }}>
                <Box
                    component="img"
                    alt={option.item_name}
                    src={option.image}
                    sx={{ width: "16px", height: "16px", objectFit: "cover" }}
                />
                <Box>
                    {option.item_name}{" "}
                    {capacityNames && <span style={{ color: "gray" }}>({capacityNames})</span>}
                </Box>
            </Box>
        );
    }

    return <span>{props.placeholder}</span>;
};

    //console.log(edit)
    const handleUpdateProducts = async (id) => {

    // ✅ Step 1: Deep clone the formData to avoid read-only mutation errors
    // console.log('all data====',formData)
    const updatedFormData = { ...formData };

        updatedFormData.capacitydetails = JSON.parse(JSON.stringify(formData.capacitydetails));

    Object.keys(updatedFormData.capacitydetails).forEach(invId => {
      updatedFormData.capacitydetails[invId].forEach(cap => {
        if (!cap.extraPercentage || cap.extraPercentage.toString().trim() === "") {
          cap.extraPercentage = "0";
        }
        if (!cap.item_special_offer || cap.item_special_offer.toString().trim() === "") {
          cap.item_special_offer = "0";
        }
      });
    });

        const data = new FormData();
        //console.log("inside updateModal",formData)

        const newImageFiles = (formData?.images || []).filter((file) => file instanceof File);
        const existingImageUrls = formData?.image_urls?.length
            ? formData.image_urls
            : getProductImageUrls(formData);
        const hasImages =
            newImageFiles.length > 0 ||
            existingImageUrls.length > 0 ||
            (imagePreviews?.length || 0) > 0;

        if (!hasImages) {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please upload at least one image', life: 3000 });
        return;
    }
    
for (let [key, value] of Object.entries(updatedFormData)) {
    if (key === 'image_urls' || key === 'images') {
        continue;
    }
    if (Array.isArray(value)) {
        if (key === 'addons') {
            value.forEach((addonId) => {
                data.append("addons", addonId);
            });
        }
    
    } else if (key === 'capacitydetails') {
    const flattened = [];

    // Flatten the grouped inventory-wise array into a flat list
    Object.entries(value).forEach(([inventoryId, items]) => {
    items.forEach((entry) => {
        const cleaned = {
            ...entry,
            inventory: parseInt(inventoryId),
            capacity: `${entry.capacityValue} ${entry.unit}`.trim()
        };

        if (cleaned.availability_type === 'all_time') {
            delete cleaned.available_from;
            delete cleaned.available_to;
            delete cleaned.available_from_datetime;
            delete cleaned.available_to_datetime;
        }
        else {
            if (cleaned.ui_startDateTime) cleaned.available_from_datetime = cleaned.ui_startDateTime;
            if (cleaned.ui_endDateTime) cleaned.available_to_datetime = cleaned.ui_endDateTime;
            // Include repeat settings
            cleaned.repeat_mode = cleaned.ui_repeatMode || 'year';
            cleaned.repeat_days = cleaned.ui_daysOfWeek || [];
        }

        // Strip UI-only fields
        delete cleaned.ui_startDateTime;
        delete cleaned.ui_endDateTime;
        delete cleaned.ui_daysOfWeek;
        delete cleaned.ui_crossesMidnight;

        flattened.push(cleaned);
    });
});


    // ✅ Append the corrected flat array
    data.append('capacitydetails', JSON.stringify(flattened));

    // ✅ Update for validation check too
    updatedFormData.capacitydetails = flattened;

    }
    else {
        // console.log('update adonnn------------------',key,value)
        data.append(key, typeof value === 'boolean' ? value.toString() : value);
    }
}


    const shouldReplaceImages = newImageFiles.length > 0;
    data.append('replace_images', shouldReplaceImages ? 'true' : 'false');
    newImageFiles.forEach((file) => {
        data.append('images', file);
    });
    data.append('inventory_id', selectedHub);  


// ✅ Log FormData contents
console.log("🧾 Final FormData:");
for (let [key, val] of data.entries()) {
    if (key === 'capacities') {
        try {
            const parsed = JSON.parse(val);
            console.log(`${key}:`, parsed); // ✅ full object/array
        } catch {
            console.log(`${key}:`, val); // fallback
        }
    } else if (key === 'images') {
        console.log(`${key}:`, val.name); // just show image filename
    } else {
        console.log(`${key}:`, val);
    }
}
        try{
            setLoading(true);
            await validationSchema.validate(updatedFormData, { abortEarly: false });
            setErrors({});
        const response = await CustomAxios.put(`products/update/${id}/`, data);   
            toast.current.show({ severity: 'success', summary: 'Success', detail: 'Product updates Successfully', life: 3000 });
            getProducts()
            handleClose()
            setFormData([])
            dispatch(updateModal(false))
            setLoading(false)
            
        }
        catch (validationErrors) {
            setLoading(false);
            if (validationErrors.name === "ValidationError") {
              const formErrors = {};
              validationErrors.inner.forEach((error) => {
                formErrors[error.path] = error.message;
              });
              setErrors(formErrors);
              setLoading(false);
            } else if (axios.isAxiosError(validationErrors)) {
              console.error("Axios error:", validationErrors);
              
              // Handle backend validation errors
              if (validationErrors.response && validationErrors.response.data) {
                const errorData = validationErrors.response.data;
                
                // Handle Django validation errors (array format)
                if (Array.isArray(errorData)) {
                    const cleanMessages = errorData.map(error => {
                        // Handle ErrorDetail objects
                        if (error && typeof error === 'object' && error.string) {
                            return error.string;
                        }
                        // Handle plain strings
                        return String(error);
                    });
                    const errorMessage = cleanMessages.join(', ');
                    toast.current.show({ 
                        severity: 'error', 
                        summary: 'Validation Error', 
                        detail: errorMessage, 
                        life: 5000 
                    });
                }
                // Handle single error message
                else if (typeof errorData === 'string') {
                  toast.current.show({ 
                    severity: 'error', 
                    summary: 'Error', 
                    detail: errorData, 
                    life: 5000 
                  });
                }
                // Handle object with error details
                else if (typeof errorData === 'object') {
                    let errorMessage = errorData.detail || errorData.message || JSON.stringify(errorData);
                    
                    // Handle Django ErrorDetail string format
                    if (typeof errorMessage === 'string' && errorMessage.includes('ErrorDetail')) {
                        // Extract the actual message from ErrorDetail string format
                        // Handles formats like: [ErrorDetail(string='message', code='invalid')]
                        const match = errorMessage.match(/string='([^']+)'/);
                        if (match) {
                            errorMessage = match[1];
                        } else {
                            // Fallback: try to extract any quoted string
                            const fallbackMatch = errorMessage.match(/'([^']+)'/);
                            if (fallbackMatch) {
                                errorMessage = fallbackMatch[1];
                            }
                        }
                    }
                    
                    toast.current.show({ 
                        severity: 'error', 
                        summary: 'Error', 
                        detail: errorMessage, 
                        life: 5000 
                    });
                }
                else {
                  toast.current.show({ 
                    severity: 'error', 
                    summary: 'Update failed', 
                    detail: 'Something went wrong.', 
                    life: 3000 
                  });
                }
              } else {
                toast.current.show({ 
                  severity: 'error', 
                  summary: 'Update failed', 
                  detail: 'Something went wrong.', 
                  life: 3000 
                });
              }
            } else {
              console.error("Unexpected error:", validationErrors);
              toast.current.show({ 
                severity: 'error', 
                summary: 'Error', 
                detail: validationErrors.message || 'Something went wrong.', 
                life: 3000 
              });
            }
          }
    }

    //console.log(formData)
    //console.log("images-------------",imagePreviews)

    const validationSchema = Yup.object().shape({
        item_name: Yup.string().required("Name is required"),
        item_description: Yup.string().required("Description is required"),
        item_details: Yup.string().required("Details is required"),
        item_category: Yup.string().required("Category is required"),
        item_criteria: Yup.string().required("Criteria is required"),
        capacitydetails: Yup.array().of(
            Yup.object().shape({
                //   item_capacity: Yup.string()
                //   .required("capacity is required"),
                  item_price: Yup.string()
                  .matches(/^\d+(\.\d{1,2})?$/, "Price must contain only digits")
                  .required("Price is required"),
                  item_tax: Yup.string()
                  .matches(/^\d+(\.\d{1,2})?$/, "Tax must contain only digits")
                  .required("Tax is required"),
                  item_offers_price: Yup.string()
                  .matches(/^\d+(\.\d{1,2})?$/, "Offers price must contain only digits")
                  .required("Offers is required"),
                  item_selling_price: Yup.string()
                  .matches(/^\d+(\.\d{1,2})?$/, "Selling price must contain only digits")
                  .required("Selling is required"),
                  capacityValue: Yup.string()
                  .required("capacityValue is required"),
                  unit: Yup.string()
                  .required("unit is required"),
                  availability_type: Yup.string().required("Availability type is required"),
                 available_from: Yup.string().when('availability_type', (availability_type, schema) => {
                return availability_type === 'specific'
                    ? schema.required('Available From time is required')
                    : schema.notRequired();
                }),
                available_to: Yup.string().when('availability_type', (availability_type, schema) => {
                return availability_type === 'specific'
                    ? schema.required('Available To time is required')
                    : schema.notRequired();
                }),

            })
        ),
      });
      console.log(errors)

      const [timePickerData, setTimePickerData] = useState({
        cap: null,
        inventoryId: null,
        capIndex: null
        });


            const handleTimeChange = (field, value) => {
            const newTime = dayjs(value).format('HH:mm:ss');
            setTimePickerData(prev => ({
                ...prev,
                cap: {
                ...prev.cap,
                [field]: newTime
                }
            }));
        };


        const handleSaveTime = () => {
        const { cap, inventoryId, capIndex } = timePickerData;

        const from = cap.available_from || '';
        const to = cap.available_to || '';

        const newErrors = {
            available_from: !from ? 'Please select Available From time' : '',
            available_to: !to ? 'Please select Available To time' : ''
        };

        // If any error exists, stop save and show error messages
        if (newErrors.available_from || newErrors.available_to) {
            setModalErrors(newErrors);
            return;
        }

        // Validate ordering: Available To must be later than Available From (same-day window)
        const toMinutes = (() => { const [h,m,s] = to.split(':').map(Number); return h*60 + m + (s? s/60 : 0); })();
        const fromMinutes = (() => { const [h,m,s] = from.split(':').map(Number); return h*60 + m + (s? s/60 : 0); })();

        if (toMinutes <= fromMinutes) {
            setModalErrors({
                available_from: '',
                available_to: 'Available To must be later than Available From'
            });
            return;
        }

        // Reset error if all good
        setModalErrors({ available_from: '', available_to: '' });

        // Proceed to save
        setFormData(prev => {
            const updated = [...prev.capacitydetails[inventoryId]];
            updated[capIndex] = {
            ...updated[capIndex],
            available_from: from,
            available_to: to
            };

            return {
            ...prev,
            capacitydetails: {
                ...prev.capacitydetails,
                [inventoryId]: updated
            }
            };
        });

        setTimePickerData({
            cap: null,
            inventoryId: null,
            capIndex: null
        });

        setOpenTimeModal(false);
        };

        const handleCloseCategoryModal = () => {
            setErrors({})
            dispatch(updateModal(false)); 
            dispatch(updateEdit(false))
            dispatch(updateCategoryDetails({
                category_name: "",
                invetory_list:[],
                category_image: []
            }))
            setImagePreviews([])
        };

        const validateCapacityDateRanges = () => {
            // Returns an object like { [index]: { available_from_datetime?: string, available_to_datetime?: string } }
            const capErrors = {};
            try {
                const capacitydetails = formData?.capacitydetails || {};
                Object.keys(capacitydetails).forEach((invId) => {
                    const caps = capacitydetails[invId] || [];
                    caps.forEach((cap, index) => {
                        if (cap?.availability_type === 'specific') {
                            const start = cap.ui_startDateTime ? new Date(cap.ui_startDateTime) : (cap.available_from_datetime ? new Date(cap.available_from_datetime) : null);
                            const end = cap.ui_endDateTime ? new Date(cap.ui_endDateTime) : (cap.available_to_datetime ? new Date(cap.available_to_datetime) : null);
                            if (!start) {
                                capErrors[index] = { ...(capErrors[index] || {}), available_from_datetime: 'Available From is required' };
                            }
                            if (!end) {
                                capErrors[index] = { ...(capErrors[index] || {}), available_to_datetime: 'Available To is required' };
                            }
                            if (start && end) {
                                if (end < start && end.toDateString() !== start.toDateString()) {
                                    capErrors[index] = { ...(capErrors[index] || {}), available_to_datetime: 'End cannot be earlier than Start' };
                                }
                            }
                        }
                    });
                });
            } catch (e) {}
            return capErrors;
        };

        const handleSaveCampaigns = async () => {
            const data = new FormData();
        
            for (const [key, value] of Object.entries(formData)) {
                if (Array.isArray(value)) {
                       if (key === "category_image") {
                           console.log("we are here")
                           value.forEach((file) => {
                               if (file instanceof File) {
                                   console.log("we are here 2")
                                   data.append(key, file);
                               } else {
                                   console.error(`Expected a File object, but received:`, file);
                               }
                           });
                       }
                       else{
                           data.append(key, JSON.stringify(value));
                       }
                   } else {
                       data.append(key, value);
                   }
               }
        
            try {
                const capErrors = validateCapacityDateRanges();
                if (Object.keys(capErrors).length) {
                    setErrors((prev) => ({ ...prev, capacitydetails: capErrors }));
                    return;
                }
                await categoryValidationSchema.validate(formData, { abortEarly: false });
                setErrors({});
        
                if (data) {
                    setLoading(true);
        
                    await CustomAxios.post(`category_create/`, data)
                        .then((res) => {
                            toast.current.show({
                                severity: 'success',
                                summary: 'Success',
                                detail: 'Category Added Successfully',
                                life: 3000,
                            });
                            getCategory();
                            getInventory();
                            handleCloseCategoryModal();
                            setFormData([]);
                            dispatch(updateModal(false));
                            setLoading(false);
                        });
                }
            } catch (error) {
                if (error.name === "ValidationError") {
                    const formErrors = {};
                    error.inner.forEach((err) => {
                        formErrors[err.path] = err.message;
                    });
                    setErrors(formErrors);
                    setLoading(false);
                } 
                // Handle duplicate description error from the backend
                else if (
                    error.response &&
                    error.response.data
                ) {
                    setErrors({ category_name: "Category Name already exists" });
                    setLoading(false); // Ensure loading is stopped for this error
                } else {
                    console.error("Error while saving campaign:", error);
                    setLoading(false); // Stop loading on other errors as well
                }
                setLoading(false); // Stop loading on validation error
            }
        };

        const handleUpdateCampaigns = async (id) => {
            const data = new FormData();
            console.log(data)
            for (const [key, value] of Object.entries(formData)) {
             if (Array.isArray(value)) {
                    if (key === "category_image") {
                        console.log("we are here")
                        value.forEach((file) => {
                            if (file instanceof File) {
                                console.log("we are here 2")
                                data.append(key, file);
                            } else {
                                console.error(`Expected a File object, but received:`, file);
                            }
                        });
                    }
                    else{
                        data.append(key, value);
                    }
                } else {
                    data.append(key, value);
                }
            }
            console.log(data)
        
            try {
                const capErrors = validateCapacityDateRanges();
                if (Object.keys(capErrors).length) {
                    setErrors((prev) => ({ ...prev, capacitydetails: capErrors }));
                    setLoading(false);
                    return;
                }
                setLoading(true);
                await categoryValidationSchema.validate(formData, { abortEarly: false });
                setErrors({});
        
                await CustomAxios.put(`category_update/${id}/`, data)
                    .then((res) => {
                        toast.current.show({
                            severity: 'success',
                            summary: 'Success',
                            detail: 'Category updated successfully',
                            life: 3000,
                        });
                        getCategory();
                        getInventory();
                        handleCloseCategoryModal();
                        setFormData([]);
                        dispatch(updateModal(false));
                        setLoading(false);
                    });
            } catch (error) {
                if (error.name === "ValidationError") {
                    const formErrors = {};
                    error.inner.forEach((err) => {
                        formErrors[err.path] = err.message;
                    });
                    setErrors(formErrors);
                    setLoading(false);
                } 
                // Handle duplicate description error from the backend
                else if (
                    error.response &&
                    error.response.data
                ) {
                    setErrors({ category_name: "Category Name already exists" });
                    setLoading(false); // Ensure loading is stopped for this error
                } else {
                    console.error("Error while updating campaign:", error);
                    setLoading(false); // Stop loading on other errors as well
                }
            }
        };

        const categoryValidationSchema = Yup.object().shape({
            category_name: Yup.string().required("Category Name is required"),
            invetory_list: Yup.array().required("Inventory List is required"),
            category_image: Yup.array()
            .of(
                Yup.mixed().test("file-or-url", "Each item must be a valid file or URL", (value) => {
                    return typeof value === "string" || value instanceof File;
                })
            )
            .min(1, "At least one image is required")
            .required("Images are required")
        });



    return (
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%" ,padding:"30px"}}>
            <Toast ref={toast} />
            <ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" transition="Bounce" />
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px",marginBottom:"20px" }}>
                <Typography sx={{ fontSize: "16px", fontWeight: "700", lineHeight: "24px" }}>Product Management</Typography>
                <Typography sx={{ fontSize: "14px", fontWeight: "500", lineHeight: "22px" }}>Product Details</Typography>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%",marginBottom:"30px" }}>
                <Box sx={{ position: "relative" }}>
                    <InputBase sx={{ backgroundColor: "white", height: "32px", width: "100%", maxWidth: "268px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px 5px 40px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} onChange={(e) => dispatch(updatesearchProduct(e.target.value))} placeholder="Search item name" />
                    <SearchIcon sx={{ position: "absolute", left: "12px", top: "5px", width: "20px", height: "20px" }} />
                </Box>
                {canManageProducts && (
                    <Button variant="contained" onClick={handleOpen} sx={{ textTransform: "none" }}> Add Product</Button>
                )}
            </Box>
            <ProductTable />
            <Modal
                open={modal}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{ zIndex: 1000 }}
            >
                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '100%', maxWidth: "1500px", height: "697px", backgroundColor: 'white', }}>
                    <Box sx={{ height: "46px important", padding: "12px 24px", backgroundColor: "#EEEEEE", display: "flex", alignItems: "center" }}>
                        <Typography sx={{ fontSize: "14", fontWeight: "500", lineHeight: "22px" }}> {edit ? "Edit Product" : "Add Product"}</Typography>
                    </Box>
                    <Box >
                        <Box sx={{ padding: "24px", display: "flex", gap: "16px", flexDirection: "column", height: "590px", overflowY: "auto" }}>
                            {/* <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }} >Hub<span style={{ color: "red", marginLeft: "5px" }}>*</span></Typography>
                                <Dropdown onChange={handleChange} value={formData.inventory_id} options={inventory} name="inventory_id" optionLabel="name"  optionValue="value"    style={{ zIndex: "1000", height: "32px", width: "192px" }}
                                    placeholder="Select Hub" className="w-full md:w-14rem" checkmark={true} highlightOnSelect={false} />
                                    {errors.inventory_id && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{errors.inventory_id}</Typography>}
                            </Box> */}
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Inventory List</Typography>
                                <MultiSelect
                                    value={formData.inventory}
                                    onChange={handleInvChange}
                                    options={filteredInventory}
                                    optionValue="value"
                                    optionLabel="name"
                                    name="inventory"
                                    placeholder="Select Inventory List"
                                    className="w-full md:w-14rem"
                                    checkmark={true}
                                    highlightOnSelect={false}
                                    disabled={localStorage.getItem('role') === 'supervisor' && JSON.parse(localStorage.getItem('hub')).length === 1}
                                />
                                {errors.inventory && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{errors.inventory}</Typography>}
                            </Box>
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Name</Typography>
                                <InputBase value={formData.item_name} sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Enter product name" name="item_name" onChange={handleChange} />
                                {errors.item_name && <Typography style={{ color: "red" ,  fontSize: "12PX", fontWeight: "400", lineHeight: "22px"  }}>{errors.item_name}</Typography>}
                            </Box>
                            <Box sx={{ width: "100%", display: "flex", gap: "16px" }}>
                                <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }} name="item_category">category</Typography>
                                    <Dropdown value={formData.item_category} onChange={handleChange} options={category} name="item_category" optionLabel="name" style={{ zIndex: "1000" }}
                                        placeholder="Select category" className="w-full md:w-14rem" checkmark={true} highlightOnSelect={false} />
                                {errors.item_category && <Typography style={{ color: "red" ,  fontSize: "12PX", fontWeight: "400", lineHeight: "22px"  }}>{errors.item_category}</Typography>}

                                </Box>
                                <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }} name="item_sub_category">sub category</Typography>
                                    <Dropdown value={formData.item_sub_category} onChange={handleChange} options={subCategory} name="item_sub_category" optionLabel="name" style={{ zIndex: "1000" }}
                                        placeholder="Select category" className="w-full md:w-14rem" checkmark={true} highlightOnSelect={false} disabled={formData.item_category === "Addon"}/>

                                </Box>
                                <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }} >criteria</Typography>
                                    <Dropdown value={formData.item_criteria} onChange={handleChange} options={criteria} optionLabel="name" name="item_criteria"
                                        placeholder="Select criteria" className="w-full md:w-14rem" checkmark={true} highlightOnSelect={false} />
                                {errors.item_criteria && <Typography style={{ color: "red" ,  fontSize: "12PX", fontWeight: "400", lineHeight: "22px"  }}>{errors.item_criteria}</Typography>}

                                </Box>
                                {/* <Box sx={{ width: "50%", display: "flex", flexDirection: "row",marginTop:"25px", gap: "10px", alignItems:"center", justifyContent:"center" }}>
                                    <Checkbox onChange={handleChange} checked={formData.bogo===true?true:false} name="bogo"/>
                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }} >Buy One Get One Free</Typography>
                                    <Dropdown value={formData.item_criteria} onChange={handleChange} options={criteria} optionLabel="name" name="item_criteria"
                                        placeholder="Select criteria" className="w-full md:w-14rem" checkmark={true} highlightOnSelect={false} />
                                    

                                </Box> */}
                                <Box sx={{ width: "50%", display: "flex", flexDirection: "row",marginTop:"25px", gap: "10px", alignItems:"center", justifyContent:"center" }}>
                                    <Checkbox onChange={handleChange} checked={formData.shinos_choice===true?true:false} name="shinos_choice" disabled={formData.item_category === "Addon"}/>
                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }} >Shino's Special</Typography>
                                    {/* <Dropdown value={formData.item_criteria} onChange={handleChange} options={criteria} optionLabel="name" name="item_criteria"
                                        placeholder="Select criteria" className="w-full md:w-14rem" checkmark={true} highlightOnSelect={false} /> */}
                                </Box>
                                <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Add On</Typography>
                                    <MultiSelect
                                        onChange={handleChange}
                                        value={formData.addons}   
                                        options={products}
                                        name="addons"             
                                        optionLabel="item_name" 
                                        optionValue="id" 
                                        style={{ zIndex: "1000", height: "32px" }}
                                        placeholder="Select Product"
                                        className="w-full md:w-14rem"
                                        valueTemplate={selectedCountryTemplate}
                                        itemTemplate={countryOptionTemplate}
                                        filter filterBy="item_name"
                                        disabled={formData.item_category === "Addon"}
                                    />
                                </Box>
                            </Box>
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Description</Typography>
                                <InputBase value={formData.item_description} sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Enter product description" name="item_description" onChange={handleChange} />
                                {errors.item_description && <Typography style={{ color: "red" ,  fontSize: "12PX", fontWeight: "400", lineHeight: "22px"  }}>{errors.item_description}</Typography>}
                            </Box>
                            <Editor style={{ height: '135px' }} name="item_details" value={formData.item_details} onTextChange={handleChange} />
                            {errors.item_details && <Typography style={{ color: "red" ,  fontSize: "12PX", fontWeight: "400", lineHeight: "22px"  }}>{errors.item_details}</Typography>}
                            {formData?.inventory?.map((invId) => (
                                <Box key={invId} sx={{ border: '1px solid #ccc', borderRadius: '8px', padding: '16px', marginBottom: '16px' }}>
                                    <Typography sx={{ fontSize: "16px", fontWeight: "600", marginBottom: "8px" }}>
                                        Inventory: {
                                                        filteredInventory.find(item => item.value === invId)?.name || `ID: ${invId}`
                                                        }
                                    </Typography>

                                    {Array.isArray(formData.capacitydetails?.[invId]) &&
                                        formData.capacitydetails[invId].map((capacityDetail, index) => (
                                            <Box key={index} sx={{ width: "100%", display: "flex", gap: "16px", alignItems: "flex-end", marginBottom: "10px" }}>
                                                
                                                <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                                <Typography sx={{ fontSize: "14px", fontWeight: 400, lineHeight: "22px" }}>Capacity</Typography>               
                                                <Box sx={{ display: "flex", gap: "5px" }}>
                                                    <InputBase
                                                    value={capacityDetail.capacityValue}
                                                    name="capacityValue"
                                                    onChange={(e) => handleCapacityChange(invId, index, e)}
                                                    sx={{
                                                        backgroundColor: "white", width: "100px", height: "32px", borderRadius: "2px", border: "1px solid",
                                                        borderColor: errors[`capacitydetails[${index}].capacityValue`] ? "red" : "secondary.border",
                                                        padding: "5px 12px",
                                                        // fontSize: "14px",
                                                        // fontWeight: 400,
                                                        // lineHeight: "22px",
                                                        // color: "black"
                                                    }}
                                                    placeholder="Add Capacity"
                                                    />
                                                    <Dropdown
                                                    value={capacityDetail.unit}
                                                    onChange={(e) => handleCapacityChange(invId, index, e)}
                                                    options={capacity}
                                                    optionLabel="name"
                                                    name="unit"
                                                    placeholder="Select Unit"
                                                    style={{ width: "100px", height: "32px",
                                                        // border: "1px solid",
                                                        // borderRadius: "2px",
                                                        borderColor: errors[`capacitydetails[${index}].unit`] ? "red" : "#ced4da",
                                                        // padding: "4px"
                                                    }}
                                                    />
                                                </Box>
                                                </Box>

                                                <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Price</Typography>
                                                    <InputBase value={capacityDetail.item_price} name="item_price" sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor:  errors[`capacitydetails[${index}].item_price`] ? 'red' :"secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Enter Product price"  onChange={(e) => handleCapacityChange(invId, index, e)} />
                                                </Box>

                                                <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Offer Price</Typography>
                                                    <InputBase value={capacityDetail.item_offers_price} name="item_offers_price" sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: errors[`capacitydetails[${index}].item_offers_price`] ? 'red' :"secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Enter Product offer price"  onChange={(e) => handleCapacityChange(invId, index, e)} />
                                                </Box>

                                                <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                                    <Typography sx={{ fontSize: "14px", fontWeight: "400", lineHeight: "22px" }}>Margin</Typography>
                                                    <InputBase 
                                                        value={capacityDetail.extraPercentage ?? '0'}
                                                        name={`extra_percentage_${index}`} 
                                                        sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} 
                                                        placeholder="Enter Selling Percentage" 
                                                        onChange={(e) => handleExtraPercentageChange(invId, index, e.target.value)}
                                                        onBlur={() => {
                                                        if (capacityDetail.extraPercentage === '') {
                                                            handleExtraPercentageChange(index, '0');
                                                        }
                                                        }}
                                                    />
                                                </Box>
                                                <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Selling Price</Typography>
                                                    <InputBase value={capacityDetail.item_selling_price} name="item_selling_price" sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: errors[`capacitydetails[${index}].item_selling_price`] ? 'red' :"secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Enter Product selling price" onChange={(e) => handleCapacityChange(invId, index, e)} />
                                                </Box>
                                                <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Tax %</Typography>
                                                    <InputBase value={capacityDetail.item_tax} name="item_tax" sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: errors[`capacitydetails[${index}].item_tax`] ? 'red' :"secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Enter Product Tax %" onChange={(e) => handleCapacityChange(invId, index, e)} />
                                                </Box>

                                                <Box 
                                                    sx={{
                                                        width: "50%", 
                                                        display: "flex", 
                                                        flexDirection: "column",
                                                         gap: "10px",
                                                     }}
                                                     >
                                                    <Typography
                                                        sx={{
                                                        fontSize: "14px",
                                                        fontWeight: "400",
                                                        lineHeight: "22px",
                                                        }}
                                                    >
                                                        Special Offer
                                                    </Typography>
                                                        <InputBase
                                                        value={capacityDetail.item_special_offer}
                                                        name="item_special_offer"
                                                        sx={{
                                                        backgroundColor: "white",
                                                        width: "100%",
                                                        height: "32px",
                                                        borderRadius: "2px",
                                                        border: "1px solid",
                                                        borderColor: errors[`capacitydetails[${index}].item_special_offer`]
                                                            ? "red"
                                                            : "secondary.border",
                                                        padding: "5px 12px",
                                                        fontSize: "14px",
                                                        fontWeight: "400",
                                                        lineHeight: "22px",
                                                        color: "black",
                                                        }}
                                                        placeholder="Enter Product Special Offer"
                                                        type="text"
                                                        onChange={(e) => {
                                                            const numericValue = e.target.value.replace(/[^0-9]/g, "");
                                                            handleCapacityChange(invId, index, { target: { name: e.target.name, value: numericValue } });
                                                        }}
                                                        endAdornment={
                                                        <InputAdornment position="end" sx={{ fontSize: "14px", fontWeight: "400", color: "black" }}>
                                                            % off
                                                        </InputAdornment>
                                                        }
                                                    />
                                                </Box>
                                           
                                        
                                          
                                            <Modal open={openTimeModal} onClose={() => setOpenTimeModal(false)}>
                                                <Box sx={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    width: 300,
                                                    bgcolor: 'background.paper',
                                                    boxShadow: 24,
                                                    p: 4,
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: '20px'
                                                }}>
                                                    <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>Select Availability Time</Typography>

                                                    <Box>
                                                        <Typography>Available From</Typography>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <MobileTimePicker
                                                                ampm={false}
                                                                value={capacityDetail.available_from ? dayjs(capacityDetail.available_from, 'HH:mm:ss') : null}

                                                                onChange={(newTime) => handleTimeChange('available_from', newTime)}
                                                                />
                                                        </LocalizationProvider>
                                                        {modalErrors.available_from && (
                                                            <Typography sx={{ fontSize: "12px", color: "red", mt: "4px" }}>
                                                            {modalErrors.available_from}
                                                            </Typography>
                                                        )}
                                                    </Box>

                                                    <Box>
                                                        <Typography>Available To</Typography>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <MobileTimePicker
                                                                ampm={false}
                                                                value={capacityDetail.available_to ? dayjs(capacityDetail.available_to, 'HH:mm:ss') : null}
                                                                onChange={(newTime) => handleTimeChange('available_to', newTime)}
                                                            />
                                                        </LocalizationProvider>
                                                         {modalErrors.available_to && (
                                                            <Typography sx={{ fontSize: "12px", color: "red", mt: "4px" }}>
                                                            {modalErrors.available_to}
                                                            </Typography>
                                                        )}
                                                    </Box>

                                                    <Button variant="contained" onClick={handleSaveTime}>Save</Button>
                                                </Box>
                                            </Modal>

                                            <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Availability</Typography>
                                                    <Dropdown
                                                        value={capacityDetail.item_available}
                                                        onChange={(e) => handleCapacityChange(invId, index, e)}
                                                        options={availability}
                                                        optionLabel="name"
                                                        name="item_available"
                                                        placeholder="Select availability" 
                                                        className="w-full md:w-14rem" 
                                                        checkmark={true} 
                                                        highlightOnSelect={false}
                                                    />
                                                </Box>
                                                <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Available Type</Typography>

                                                    <Dropdown
                                                        onChange={(e) => handleCapacityChange(invId, index, { target: { name: 'availability_type', value: e.value } })}
                                                        value={capacityDetail?.availability_type}
                                                        options={availabilityOptions}
                                                        name="availability_type"
                                                        optionLabel="label"
                                                        optionValue="value"
                                                        placeholder="Select Availability"
                                                        className="w-full md:w-14rem"
                                                        style={{ width: "100px", height: "32px",
                                                        borderColor: errors[`capacitydetails[${index}].availability_type`] ? "red" : "#ced4da",
                                                    }}
                                                    />
                                                </Box>
                                                 {capacityDetail.availability_type === 'specific' && (
                                                    <Box sx={{ display: "flex", gap: "16px", mt: 1 }}>
                                                        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: "8px", width: "105px" }}>
                                                            <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px", flexWrap: "nowrap", whiteSpace: "nowrap" }}>Available From</Typography>
                                                            <InputBase
                                                                value={capacityDetail.ui_startDateTime
                                                                    ? format(new Date(capacityDetail.ui_startDateTime), 'MMM d, yyyy h:mm aa')
                                                                    : (capacityDetail.available_from_datetime 
                                                                        ? format(new Date(capacityDetail.available_from_datetime), 'MMM d, yyyy h:mm aa')
                                                                        : (capacityDetail.available_from || ''))}
                                                                readOnly
                                                                sx={{ backgroundColor: 'white', width: '100%', height: '32px', borderRadius: '2px', border: '1px solid', borderColor: (!capacityDetail.ui_startDateTime && !capacityDetail.available_from_datetime && !capacityDetail.available_from) || (errors.capacitydetails?.[index]?.available_from) ? 'red' : 'secondary.border', padding: '5px 12px', fontSize: '14px', fontWeight: 400, lineHeight: '22px', color: 'black' }}
                                                                onClick={() => {
                                                                    setDateRangeContext({ inventoryId: invId, capIndex: index });
                                                                    const startDate = capacityDetail.ui_startDateTime 
                                                                        ? new Date(capacityDetail.ui_startDateTime)
                                                                        : (capacityDetail.available_from_datetime 
                                                                            ? new Date(capacityDetail.available_from_datetime)
                                                                            : null);
                                                                    const endDate = capacityDetail.ui_endDateTime 
                                                                        ? new Date(capacityDetail.ui_endDateTime)
                                                                        : (capacityDetail.available_to_datetime 
                                                                            ? new Date(capacityDetail.available_to_datetime)
                                                                            : null);
                                                                    const repeatMode = capacityDetail.ui_repeatMode || 'year';
                                                                    
                                                                    setModalStartDateTime(startDate);
                                                                    setModalEndDateTime(endDate);
                                                                    setModalDaysOfWeek(Array.isArray(capacityDetail.ui_daysOfWeek) ? capacityDetail.ui_daysOfWeek : []);
                                                                    setModalRepeatMode(repeatMode);
                                                                    
                                                                    // If no end date exists, calculate it based on repeat mode
                                                                    if (startDate && !endDate) {
                                                                        const calculatedEndDate = calculateEndDate(startDate, repeatMode);
                                                                        if (calculatedEndDate) {
                                                                            const newEndDate = new Date(calculatedEndDate);
                                                                            newEndDate.setHours(startDate.getHours());
                                                                            newEndDate.setMinutes(startDate.getMinutes());
                                                                            newEndDate.setSeconds(startDate.getSeconds());
                                                                            setModalEndDateTime(newEndDate);
                                                                        }
                                                                    }
                                                                    
                                                                    setModalError(''); // Clear any previous errors
                                                                    setOpenDateRangeModal(true);
                                                                }}
                                                            />
                                                         {errors.capacitydetails?.[index]?.available_from && (
                                                            <Typography sx={{ color: "red", fontSize: "12px", mt: "-6px" }}>
                                                            {errors.capacitydetails[index].available_from}
                                                            </Typography>
                                                        )}
                                                    </Box>

                                                    <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: "8px" }}>
                                                            <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px", flexWrap: "nowrap", whiteSpace: "nowrap" }}>Available To</Typography>
                                                            <InputBase
                                                                value={capacityDetail.ui_endDateTime
                                                                    ? format(new Date(capacityDetail.ui_endDateTime), 'MMM d, yyyy h:mm aa')
                                                                    : (capacityDetail.available_to_datetime 
                                                                        ? format(new Date(capacityDetail.available_to_datetime), 'MMM d, yyyy h:mm aa')
                                                                        : (capacityDetail.available_to || ''))}
                                                                readOnly
                                                                sx={{ backgroundColor: 'white', width: '100%', height: '32px', borderRadius: '2px', border: '1px solid', borderColor: (!capacityDetail.ui_endDateTime && !capacityDetail.available_to_datetime && !capacityDetail.available_to) || (errors.capacitydetails?.[index]?.available_to) ? 'red' : 'secondary.border', padding: '5px 12px', fontSize: '14px', fontWeight: 400, lineHeight: '22px', color: 'black' }}
                                                                onClick={() => {
                                                                    setDateRangeContext({ inventoryId: invId, capIndex: index });
                                                                    const startDate = capacityDetail.ui_startDateTime 
                                                                        ? new Date(capacityDetail.ui_startDateTime)
                                                                        : (capacityDetail.available_from_datetime 
                                                                            ? new Date(capacityDetail.available_from_datetime)
                                                                            : null);
                                                                    const endDate = capacityDetail.ui_endDateTime 
                                                                        ? new Date(capacityDetail.ui_endDateTime)
                                                                        : (capacityDetail.available_to_datetime 
                                                                            ? new Date(capacityDetail.available_to_datetime)
                                                                            : null);
                                                                    const repeatMode = capacityDetail.ui_repeatMode || 'year';
                                                                    
                                                                    setModalStartDateTime(startDate);
                                                                    setModalEndDateTime(endDate);
                                                                    setModalDaysOfWeek(Array.isArray(capacityDetail.ui_daysOfWeek) ? capacityDetail.ui_daysOfWeek : []);
                                                                    setModalRepeatMode(repeatMode);
                                                                    
                                                                    // If no end date exists, calculate it based on repeat mode
                                                                    if (startDate && !endDate) {
                                                                        const calculatedEndDate = calculateEndDate(startDate, repeatMode);
                                                                        if (calculatedEndDate) {
                                                                            const newEndDate = new Date(calculatedEndDate);
                                                                            newEndDate.setHours(startDate.getHours());
                                                                            newEndDate.setMinutes(startDate.getMinutes());
                                                                            newEndDate.setSeconds(startDate.getSeconds());
                                                                            setModalEndDateTime(newEndDate);
                                                                        }
                                                                    }
                                                                    
                                                                    setModalError(''); // Clear any previous errors
                                                                    setOpenDateRangeModal(true);
                                                                }}
                                                            />
                                                        {errors.capacitydetails?.[index]?.available_to && (
                                                            <Typography sx={{ color: "red", fontSize: "12px", mt: "-6px" }}>
                                                            {errors.capacitydetails[index].available_to}
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                    </Box>
                                                )}
                                                <Tooltip title="Remove" arrow>
                                                    <IconButton type="button" onClick={() => handleRemoveCapacity(invId, index)}>
                                                        <RemoveCircleOutlineOutlinedIcon/>
                                                    </IconButton>
                                                </Tooltip>
                                            </Box>
                                        ))}

                                    <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
                                        <Button variant="outlined" onClick={() => handleAddCapacity(invId)}>
                                            Add Capacity to { filteredInventory.find(item => item.value === invId)?.name || `ID: ${invId}` }
                                        </Button>
                                    </Box>
                                </Box>
                            ))}



                            {/* <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                            <Tooltip title="Add More Capacity" arrow>
                                <Button variant="outlined" sx={{ border: "2px dotted grey", width: "150px" }}><Typography sx={{ fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} onClick={handleAddCapacity}>Add Capacity</Typography></Button>
                            </Tooltip>
                            </Box> */}
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px',alignItems:"center" }}>
                                {imagePreviews?.map((image, index) => (
                                    <Box key={index} sx={{ width: '104px', height: '104px', border: '1px solid', borderColor: 'secondary.border', borderRadius: '8px', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', cursor: 'pointer', backgroundColor: 'background.upload', overflow: 'hidden', '&:hover .overlay': { display: 'block', }, '&:hover .delete-button': { display: 'flex', }, }}>
                                        <img src={blobSrc(image)} alt={`Uploaded ${index}`} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px', transition: 'opacity 0.3s', }} />
                                        <Box className="overlay" sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: '#00000080', display: 'none', borderRadius: '8px', }} />
                                        <Tooltip title="Delete" arrow>
                                            <IconButton className="delete-button" onClick={() => handleRemoveImage(index)} sx={{ position: 'absolute', top: "50%", left: "50%", display: 'none', transform: 'translate(-50%, -50%)', }}>
                                                <DeleteOutlineIcon sx={{ color: "white" }} />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                ))}
                                <Box
                                    sx={{ width: '104px', height: '104px', border: '1px solid', borderColor: 'secondary.border', borderRadius: '8px', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', cursor: 'pointer', backgroundColor: 'background.upload', }}>
                                    <input type="file" accept="image/*" id="upload-input" style={{ position: 'absolute', width: '104px', height: '104px', opacity: 0, cursor: 'pointer', top: 0, left: 0 }} onChange={handleImageChange} name="images" />
                                    <label htmlFor="upload-input" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <AddIcon fontSize="large" />
                                        <Typography sx={{ fontSize: "14px", fontWeight: "400", lineHeight: "22px" }}>Upload</Typography>
                                    </label>
                                </Box>
                            {errors.images && <Typography style={{ color: "red" ,  fontSize: "12PX", fontWeight: "400", lineHeight: "22px"  }}>{errors.images}</Typography>}
                            {errors.image_urls && <Typography style={{ color: "red" ,  fontSize: "12PX", fontWeight: "400", lineHeight: "22px"  }}>{errors.image_urls}</Typography>}
                            </Box>
                        </Box>

                    </Box>
                    <Box sx={{ backgroundColor: "#EEEEEE", display: "flex", alignItems: "center", position: "absolute", bottom: 0, display: "flex", justifyContent: "flex-end", width: "100%" }}>
                        <Box sx={{ padding: "12px 24px", display: "flex", gap: "20px" }}>
                            <Button variant="outlined" sx={{ textTransform: "none", color: "black", backgroundColor: "white", height: "32px", width: "67px" }} onClick={handleClose}> cancel</Button>
                            <Button variant="contained" sx={{ textTransform: "none", height: "32px", width: "67px" }} onClick={() => edit ? handleUpdateProducts(productDetails.id) : handleSaveProducts()} > {edit ? loading?<CircularProgress size="25px" sx={{color:"white"}}/>:"Update" : loading?<CircularProgress size="25px" sx={{color:"white"}}/>:"Save"}</Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>
            {/* Date & Time Range Modal */}
            <Modal open={openDateRangeModal} onClose={() => { setOpenDateRangeModal(false); setModalError(''); }}>
                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 680, bgcolor: 'background.paper', boxShadow: 24, p: 3, display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <Typography sx={{ fontSize: '16px', fontWeight: 600 }}>Select date & time range</Typography>
                    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr auto 1fr', alignItems: 'center', gap: '16px' }}>
                        <DatePicker
                            selected={modalStartDateTime}
                            onChange={handleStartDateChange}
                            showTimeSelect
                            timeFormat="hh:mm aa"
                            timeIntervals={5}
                            dateFormat="MMM d, yyyy h:mm aa"
                            withPortal
                            portalId="date-time-portal"
                            minDate={new Date()} // Disable past dates (date-only; allow past time on today)
                            customInput={<DateTextField label="Start date & time" placeholder="Start date & time" />}
                        />
                        <Typography sx={{ fontSize: '14px', color: 'text.secondary' }}>to</Typography>
                        <DatePicker
                            selected={modalEndDateTime}
                            onChange={(d) => setModalEndDateTime(d)}
                            showTimeSelect
                            timeFormat="hh:mm aa"
                            timeIntervals={5}
                            dateFormat="MMM d, yyyy h:mm aa"
                            withPortal
                            portalId="date-time-portal"
                            minDate={new Date()} // Disable past dates (date-only); allow past time on today
                            maxDate={modalRepeatMode === 'month' && modalStartDateTime ? 
                                getLastDayOfMonth(modalStartDateTime) : 
                                modalRepeatMode === 'year' && modalStartDateTime ? 
                                getLastDayOfYear(modalStartDateTime) : 
                                null} // Limit end date based on repeat mode
                            customInput={<DateTextField 
                                label={`End date & time ${modalRepeatMode === 'year' ? '(Year-end)' : modalRepeatMode === 'month' ? '(Month-end)' : ''}`} 
                                placeholder="End date & time" 
                            />}
                        />
                    </Box>
                    {modalError && (
                        <Typography sx={{ color: 'red', fontSize: '12px' }}>{modalError}</Typography>
                    )}

                    <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>Repeat on days</Typography>
                    <Box sx={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                        <Button variant={modalRepeatMode==='year'?'contained':'outlined'} size="small" onClick={() => handleRepeatModeChange('year')}>Year</Button>
                        <Button variant={modalRepeatMode==='month'?'contained':'outlined'} size="small" onClick={() => handleRepeatModeChange('month')}>Month</Button>
                        <Button variant={modalRepeatMode==='custom'?'contained':'outlined'} size="small" onClick={() => handleRepeatModeChange('custom')}>Custom</Button>
                        {modalRepeatMode === 'custom' && (
                            daysOfWeek.map((d) => {
                                const selected = Array.isArray(modalDaysOfWeek) && modalDaysOfWeek.includes(d.value);
                                return (
                                    <Button
                                        key={d.value}
                                        variant={selected ? 'contained' : 'outlined'}
                                        size="small"
                                        sx={{ minWidth: '48px', textTransform: 'none' }}
                                        onClick={() => {
                                            setModalRepeatMode('custom');
                                            const prev = Array.isArray(modalDaysOfWeek) ? modalDaysOfWeek : [];
                                            const next = selected ? prev.filter(v => v !== d.value) : [...prev, d.value];
                                            setModalDaysOfWeek(next);
                                        }}
                                    >{d.label}</Button>
                                );
                            })
                        )}
                    </Box>

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                        <Button variant="outlined" onClick={() => { setOpenDateRangeModal(false); setModalError(''); }}>Cancel</Button>
                        <Button variant="contained" onClick={() => {
                            if (!dateRangeContext) return;
                            const { inventoryId, capIndex } = dateRangeContext;
                            const start = modalStartDateTime;
                            const end = modalEndDateTime;
                            
                            // Clear any previous errors first
                            setModalError('');
                            
                            // Validation
                            if (!start || !end) { 
                                setModalError('Please select both start and end date & time'); 
                                return; 
                            }
                            
                            // Additional validation to ensure dates are valid Date objects
                            if (!(start instanceof Date) || !(end instanceof Date) || isNaN(start.getTime()) || isNaN(end.getTime())) {
                                setModalError('Please select valid start and end date & time');
                                return;
                            }
                            
                            if (modalRepeatMode === 'custom' && (!modalDaysOfWeek || modalDaysOfWeek.length === 0)) { 
                                setModalError('Please select at least one day'); 
                                return; 
                            }

                            // Check for zero-length window (same start and end)
                            if (start.getTime() === end.getTime()) {
                                setModalError('Start and end datetime cannot be the same');
                                return;
                            }


                             // Disallow same time-of-day even if dates differ (e.g., 11:00 AM to 11:00 AM on a later date)
                            const sameTimeOfDay =
                             start.getHours() === end.getHours() &&
                             start.getMinutes() === end.getMinutes() &&
                             start.getSeconds() === end.getSeconds();
                            if (sameTimeOfDay) {
                                setModalError('End time must differ from start time');
                                return;
                            }
                            
                            // Check for past calendar date (allow past times today)
                            const todayStart = new Date();
                            todayStart.setHours(0, 0, 0, 0);
                            const startDateOnly = new Date(start.getFullYear(), start.getMonth(), start.getDate());
                            const endDateOnly = new Date(end.getFullYear(), end.getMonth(), end.getDate());
                            if (startDateOnly < todayStart) {
                                setModalError('Start date cannot be in the past');
                                return;
                            }
                            if (endDateOnly < todayStart) {
                                setModalError('End date cannot be in the past');
                                return;
                            }

                            // Prevent selecting an end datetime that is earlier than the start date (different calendar day)
                            // Same-day end < start is handled as an overnight range below
                            if (end < start && end.toDateString() !== start.toDateString()) {
                                setModalError('End datetime cannot be earlier than start datetime');
                                return;
                            }
                            
                            setModalError('');

                            // Handle PM→AM midnight crossing
                            let finalEndDate = new Date(end);
                            const startMinutes = start.getHours() * 60 + start.getMinutes();
                            const endMinutes = end.getHours() * 60 + end.getMinutes();
                            const crossesMidnight = endMinutes <= startMinutes;
                            
                            // If end time is earlier than start time on the same day, increment end date by 1 day
                            if (crossesMidnight && start.toDateString() === end.toDateString()) {
                                finalEndDate = new Date(end);
                                finalEndDate.setDate(finalEndDate.getDate() + 1);
                            }

                            const startTime = format(start, 'HH:mm:ss');
                            const endTime = format(finalEndDate, 'HH:mm:ss');

                            handleCapacityChange(inventoryId, capIndex, { target: { name: 'ui_startDateTime', value: start.toISOString() } });
                            handleCapacityChange(inventoryId, capIndex, { target: { name: 'ui_endDateTime', value: finalEndDate.toISOString() } });
                            // Determine days based on repeat mode
                            const days = modalRepeatMode === 'year' ? [0,1,2,3,4,5,6] : modalDaysOfWeek;
                            handleCapacityChange(inventoryId, capIndex, { target: { name: 'ui_daysOfWeek', value: days } });
                            handleCapacityChange(inventoryId, capIndex, { target: { name: 'ui_repeatMode', value: modalRepeatMode } });
                            handleCapacityChange(inventoryId, capIndex, { target: { name: 'available_from', value: startTime } });
                            handleCapacityChange(inventoryId, capIndex, { target: { name: 'available_to', value: endTime } });
                            handleCapacityChange(inventoryId, capIndex, { target: { name: 'ui_crossesMidnight', value: crossesMidnight } });

                            setOpenDateRangeModal(false);
                        }}>Save</Button>
                    </Box>
                </Box>
            </Modal>
            <OrderModal/>
            <OrderModalDelivery/>
        </Box>
    )
}